<div class="flex h-full flex-col">
  <div
    class="w-full"
    [formGroup]="guaranteesFilterForm"
  >
    <div class="flex w-full items-center justify-between gap-2">
      <div class="flex gap-2">
        <mat-form-field class="w-[500px]">
          <mat-icon matPrefix>search</mat-icon>
          <mat-label>Пошук</mat-label>
          <input
            matInput
            [type]="'text'"
            [formControl]="fc.search"
          />
          @if (fc.search.value) {
            <button
              matSuffix
              mat-icon-button
              type="button"
              aria-label="Clear"
              (click)="clearSearchControl()"
            >
              <mat-icon matIconSuffix>close</mat-icon>
            </button>
          }
        </mat-form-field>
        @if (count() > 0) {
          <shared-info-badge
            class="my-2"
            [text]="count().toString()"
          ></shared-info-badge>
        }
      </div>

      <div class="flex gap-2">
        @if (draftPrescriptions().length > 0) {
          <button
            class="btn btn-primary mb-4"
            (click)="processDraftPrescriptions()"
          >
            {{ "prescription.action.processDrafts" | translate }}
          </button>
        }
        @if (allowCreateGuarantee()) {
          <button
            class="btn btn-primary mb-4"
            type="button"
            (click)="navigateToCreateGuarantee()"
          >
            Створити призначення
          </button>
        }
      </div>
    </div>
  </div>

  <div
    class="relative h-0 min-h-0 flex-1 overflow-y-auto pr-3"
    sharedInfiniteScroll
    [scrollLoading]="guaranteesFetching()"
    [hasNextPage]="hasNextPage()"
    (fetchNextPage)="fetchNextPage()"
  >
    <prescriptions-guarantees-list
      [allowAddPrescription]="allowCreateGuarantee()"
      [allowEditPrescription]="allowCreateGuarantee()"
      [showPrescriptionActions]="allowCreateGuarantee()"
      (guaranteeItemUpdated)="guaranteeUpdated($event)"
    >
    </prescriptions-guarantees-list>
  </div>
</div>
@if (loading()) {
  <div class="absolute inset-0 z-50 flex items-center justify-center bg-neutral-0/80">
    <shared-loader></shared-loader>
  </div>
}
@if (guaranteesFetching() && !loading()) {
  <div class="left-[50%] z-50 flex items-end justify-center">
    <shared-spin-loading [size]="24"></shared-spin-loading>
  </div>
}
